import React, {useEffect, useMemo} from 'react';
import reportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const EventNeighborhood = ({data}) => {
    const eventNeighborhood = data.eventsByNeighborhood ?? []

    const top10 = useMemo(() => {
        const localData = eventNeighborhood.slice(0, 10);

        return {
            labels: localData.map(item => reportUtils.formatText(item.neighborhoods)),
            values: localData.map(item => item.qty)
        };
    }, [eventNeighborhood]);

    const eventToExport = useMemo(() => {
        return {
            labels: eventNeighborhood.map(item => reportUtils.formatText(item.neighborhoods)),
            values: eventNeighborhood.map(item => item.qty)
        };
    }, [eventNeighborhood]);

    useEffect(() => {
        if (top10.labels.length > 0) {
            GraphicUtils.horizontalBarChart('event-neighborhood', top10.values, top10.labels, true);
        }

        if (eventToExport.labels.length > 0) {
            ReportUtils.createExportableTable(eventToExport.labels, eventToExport.values, `Eventos por bairro`);
        }

    }, [top10, eventToExport]);

    return (
        <>
            <div className="chart-report" title={"Tipo do evento"}>
                <span id={`event-neighborhood-title`} className="chart-title " htmlFor={"event-neighborhood"} >Eventos por bairro {eventToExport.labels.length > 9 ? "(TOP 10)" : "" }</span>
                <div className="mt-3" id={"event-neighborhood"}></div>
            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default EventNeighborhood;